import React from 'react';
import { Link } from 'react-router-dom';
import {
	Row, Col, Card, Form, Input, Button, Select, DatePicker,
	InputNumber, Spin, Typography,
} from 'antd';
import {
	IdcardOutlined, CarOutlined, EnvironmentOutlined, SafetyOutlined,
	CalendarOutlined, SaveOutlined, ArrowLeftOutlined, WarningOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { initHandler, ajaxViewHandler, ajaxHandler, extractResult } from '../../store/actions';
import { Helmet } from 'react-helmet';
import Config from '../../Config';
import moment from 'moment';
import { toastSuccess, toastError } from '../../utils/toast';
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;
const { TextArea } = Input;

const configClass = {
	title: 'Edit Kendaraan',
	apiUrl: {
		data: 'master/api/kendaraan-pencarian/',
		jenisKendaraan: 'master/api/jenis/kendaraan/',
		merek: 'master/api/merek/',
		tipe: 'master/api/tipe/',
		bahanBakar: 'master/api/bahan/bakar/',
		warnaPlat: 'master/api/plat/',
		fungsi: 'master/api/fungsi/',
		golongan: 'master/api/golongan/',
		kepemilikan: 'master/api/kepemilikan/',
		kabupaten: 'master/api/kabupaten/',
		kecamatan: 'master/api/kecamatan/',
		desa: 'master/api/desa/',
	},
	pageUrl: { data: '/admin/kendaraan' },
};

const config = new Config();

const DATE_FIELDS = [
	{ name: 'stnk_mulai', label: 'STNK Mulai' },
	{ name: 'stnk_akhir', label: 'STNK Akhir' },
	{ name: 'sd_swdkllj', label: 'Masa Berlaku Akhir SWDKLLJ' },
	{ name: 'tanggal_notice', label: 'Notice - Pajak Mulai' },
	{ name: 'sd_notice', label: 'Notice - Pajak Akhir' },
	{ name: 'tanggal_iwkbu', label: 'Tanggal IWKBU' },
	{ name: 'tanggal_pembayaran', label: 'Tanggal Pembayaran' },
	{ name: 'tanggal_fiskal', label: 'Tanggal Fiskal' },
];

const sectionCard = (title, icon, color, children) => (
	<Card style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', overflow: 'hidden', marginBottom: 20 }} bodyStyle={{ padding: 0 }}>
		<div style={{ padding: '14px 24px', background: `linear-gradient(135deg, ${color}22, ${color}11)`, borderBottom: `2px solid ${color}33`, display: 'flex', alignItems: 'center', gap: 10 }}>
			<span style={{ color, fontSize: 18 }}>{icon}</span>
			<Text strong style={{ fontSize: 15, color: '#222' }}>{title}</Text>
		</div>
		<div style={{ padding: '24px 28px' }}>{children}</div>
	</Card>
);

/**
 * Form edit menu Master > Kendaraan - HANYA bisa diakses superadmin/admin
 * (digerbang di routing AdminLayout.jsx + ditegakkan ulang di backend via
 * IsAdminOrSuperadminForWrite, jadi kalaupun URL ini diakses langsung oleh
 * user biasa, submit akan ditolak 403 oleh server).
 */
class FormKendaraan extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			errTitle: '', errMsg: '',
			loadingData: true,
			loadingSubmit: false,
			listJenisKendaraan: [], listMerek: [], listTipe: [],
			listBahanBakar: [], listWarnaPlat: [], listFungsi: [],
			listGolongan: [], listKepemilikan: [],
			listKabupaten: [], listKecamatan: [], listDesa: [],
		};
	}

	UNSAFE_componentWillMount() { this.props.initHandler(); }

	componentDidMount() {
		this._loadIndependentLists();
		this._loadData();
	}

	_fetchList = (url, stateKey, extraParams = '') => {
		this.props.ajaxViewHandler('get', `${url}?limit=500${extraParams}`)
			.then((action) => {
				const { isSuccess, responseMsg: data } = extractResult(action);
				if (isSuccess) this.setState({ [stateKey]: (data && data.results) || [] });
			});
	};

	_loadIndependentLists = () => {
		this._fetchList(configClass.apiUrl.jenisKendaraan, 'listJenisKendaraan');
		this._fetchList(configClass.apiUrl.bahanBakar, 'listBahanBakar');
		this._fetchList(configClass.apiUrl.warnaPlat, 'listWarnaPlat');
		this._fetchList(configClass.apiUrl.fungsi, 'listFungsi');
		this._fetchList(configClass.apiUrl.golongan, 'listGolongan');
		this._fetchList(configClass.apiUrl.kepemilikan, 'listKepemilikan');
		this._fetchList(configClass.apiUrl.kabupaten, 'listKabupaten');
	};

	_loadData = () => {
		const id = this.props.match.params.id;
		this.setState({ loadingData: true });
		this.props.ajaxViewHandler('get', configClass.apiUrl.data + id + '/')
			.then((action) => {
				const { isSuccess, responseMsg: d } = extractResult(action);
				if (!isSuccess) {
					this.setState({ loadingData: false, errTitle: 'Gagal memuat data', errMsg: this.props.responseMsg });
					return;
				}
				// Muat ulang list dependen (merek by jenis, tipe by merek+jenis+tahun,
				// kecamatan by kabupaten, desa by kecamatan) supaya cascading select
				// terisi benar walau user belum sempat mengubah parent-nya.
				if (d.jenis_kendaraan) this._fetchList(configClass.apiUrl.merek, 'listMerek', `&jenis=${d.jenis_kendaraan}`);
				if (d.merek) this._fetchList(configClass.apiUrl.tipe, 'listTipe', `&merek=${d.merek}&jenis=${d.jenis_kendaraan || ''}&tahun=${d.tahun_buat || ''}`);
				if (d.kabupaten) this._fetchList(configClass.apiUrl.kecamatan, 'listKecamatan', `&regencies=${d.kabupaten}`);
				if (d.kecamatan) this._fetchList(configClass.apiUrl.desa, 'listDesa', `&district=${d.kecamatan}`);

				this.setState({ loadingData: false });
				const dateVals = {};
				DATE_FIELDS.forEach(({ name }) => { dateVals[name] = d[name] ? moment(d[name]) : null; });
				if (this.formRef.current) {
					this.formRef.current.setFieldsValue({
						nomor_polisi: d.nomor_polisi, nomor_polisi_ex: d.nomor_polisi_ex,
						nomor_rangka: d.nomor_rangka,
						nomor_mesin: d.nomor_mesin, no_bpkb: d.no_bpkb, no_kohir: d.no_kohir,
						no_skum: d.no_skum, no_urut: d.no_urut,
						jenis_kendaraan: d.jenis_kendaraan, merek: d.merek, tipe: d.tipe,
						tahun_buat: d.tahun_buat, warna: d.warna, bahan_bakar: d.bahan_bakar,
						warna_plat: d.warna_plat, roda: d.roda, silinder: d.silinder,
						fungsi: d.fungsi, golongan: d.golongan, kepemilikan: d.kepemilikan,
						kepemilikan_ke: d.kepemilikan_ke,
						kabupaten: d.kabupaten, kecamatan: d.kecamatan, desa: d.desa,
						pemilik_nama: d.pemilik_nama, pemilik_nik: d.pemilik_nik,
						pemilik_alamat: d.pemilik_alamat, pemilik_no_hp: d.pemilik_no_hp,
						...dateVals,
					});
				}
			})
			.catch(() => this.setState({ loadingData: false, errTitle: 'Gagal memuat data', errMsg: 'Terjadi kesalahan saat memuat data.' }));
	};

	// ── Cascading: Jenis Kendaraan -> Merek -> Tipe ──────────────────────
	handleJenisChange = (val) => {
		this.formRef.current.setFieldsValue({ merek: undefined, tipe: undefined });
		this.setState({ listMerek: [], listTipe: [] });
		if (val) this._fetchList(configClass.apiUrl.merek, 'listMerek', `&jenis=${val}`);
	};

	handleMerekChange = (val) => {
		this.formRef.current.setFieldsValue({ tipe: undefined });
		this.setState({ listTipe: [] });
		const jenis = this.formRef.current.getFieldValue('jenis_kendaraan');
		const tahun = this.formRef.current.getFieldValue('tahun_buat');
		if (val) this._fetchList(configClass.apiUrl.tipe, 'listTipe', `&merek=${val}&jenis=${jenis || ''}&tahun=${tahun || ''}`);
	};

	// ── Cascading: Kabupaten -> Kecamatan -> Desa ────────────────────────
	handleKabupatenChange = (val) => {
		this.formRef.current.setFieldsValue({ kecamatan: undefined, desa: undefined });
		this.setState({ listKecamatan: [], listDesa: [] });
		if (val) this._fetchList(configClass.apiUrl.kecamatan, 'listKecamatan', `&regencies=${val}`);
	};

	handleKecamatanChange = (val) => {
		this.formRef.current.setFieldsValue({ desa: undefined });
		this.setState({ listDesa: [] });
		if (val) this._fetchList(configClass.apiUrl.desa, 'listDesa', `&district=${val}`);
	};

	handleSubmit = (values) => {
		const id = this.props.match.params.id;
		const payload = { ...values };
		DATE_FIELDS.forEach(({ name }) => {
			// Backend DRF DATE_INPUT_FORMATS cuma terima %d-%m-%Y (lihat
			// samsat/settings.py) - kirim ISO (YYYY-MM-DD) bikin serializer
			// menolak semua field tanggal dengan "Format tanggal salah".
			payload[name] = values[name] ? values[name].format('DD-MM-YYYY') : null;
		});
		this.setState({ loadingSubmit: true });
		this.props.ajaxHandler('patch', configClass.apiUrl.data + id + '/', payload, false, true)
			.then(() => {
				this.setState({ loadingSubmit: false });
				if (this.props.isSuccess) {
					toastSuccess('Data kendaraan berhasil disimpan');
					this.props.history.push(configClass.pageUrl.data);
				} else {
					this.setState({ errTitle: 'Gagal menyimpan data', errMsg: this.props.responseMsg });
					toastError('Gagal menyimpan data');
				}
			})
			.catch(() => { this.setState({ loadingSubmit: false }); toastError('Kesalahan jaringan, coba lagi'); });
	};

	// labelField: master Merek/Tipe/JenisKendaraan/dkk pakai field "nama",
	// tapi MasterRegencies/MasterDistricts/MasterVillages (kabupaten/
	// kecamatan/desa) pakai field "name" (Inggris) - beda model, beda
	// konvensi nama field, jadi HARUS bisa dipilih per pemanggilan.
	_renderSelect(field, list, placeholder, onChange, labelField = 'nama') {
		return (
			<Form.Item label={placeholder} name={field}>
				<Select allowClear showSearch optionFilterProp="children" placeholder={`Pilih ${placeholder.toLowerCase()}...`}
					style={{ borderRadius: 8 }} onChange={onChange}>
					{list.map(item => <Select.Option key={item.id} value={item.id}>{item[labelField]}</Select.Option>)}
				</Select>
			</Form.Item>
		);
	}

	render() {
		const { errTitle, errMsg, loadingData, loadingSubmit,
			listJenisKendaraan, listMerek, listTipe, listBahanBakar, listWarnaPlat,
			listFungsi, listGolongan, listKepemilikan,
			listKabupaten, listKecamatan, listDesa } = this.state;

		return (
			<div>
				<Helmet><title>{configClass.title + ' | ' + config.get_site_info().name}</title></Helmet>
				<ErrorAlertModal visible={errMsg !== ''} title={errTitle} error={errMsg} onClose={() => this.setState({ errTitle: '', errMsg: '' })} />

				<Card style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden', marginBottom: 20 }} bodyStyle={{ padding: 0 }}>
					<div style={{ padding: '16px 20px', background: 'linear-gradient(135deg, #0f2847, #1e4d8a)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10 }}>
						<div style={{ color: '#fff', fontWeight: 700, fontSize: 17 }}><CarOutlined style={{ marginRight: 8 }} />{configClass.title}</div>
						<Link to={configClass.pageUrl.data}>
							<Button icon={<ArrowLeftOutlined />} style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}>Kembali</Button>
						</Link>
					</div>
				</Card>

				{loadingData ? (
					<div style={{ textAlign: 'center', padding: 60 }}><Spin size="large" /></div>
				) : (
					<Form ref={this.formRef} layout="vertical" onFinish={this.handleSubmit}>
						{sectionCard('Data Pemilik', <IdcardOutlined />, '#fa8c16', (
							<>
								<div style={{ background: '#fffbe6', border: '1px solid #ffe58f', borderRadius: 8, padding: '10px 14px', marginBottom: 18, fontSize: 12, color: '#614700' }}>
									<WarningOutlined style={{ marginRight: 8, color: '#faad14' }} />
									Data pemilik ini bisa dipakai lebih dari satu kendaraan. Mengubah nama, NIK, alamat, atau no HP di sini akan <b>ikut berlaku untuk semua kendaraan lain</b> yang terdaftar atas nama pemilik yang sama.
								</div>
								<Row gutter={16}>
									<Col xs={24} sm={12}><Form.Item label="Nama Pemilik" name="pemilik_nama" rules={[{ required: true, message: 'Nama wajib diisi' }]}><Input style={{ borderRadius: 8 }} /></Form.Item></Col>
									<Col xs={24} sm={12}><Form.Item label="NIK" name="pemilik_nik" rules={[{ required: true, message: 'NIK wajib diisi' }]}><Input style={{ borderRadius: 8 }} /></Form.Item></Col>
									<Col xs={24} sm={12}><Form.Item label="Alamat" name="pemilik_alamat"><TextArea rows={2} style={{ borderRadius: 8 }} /></Form.Item></Col>
									<Col xs={24} sm={12}><Form.Item label="No HP" name="pemilik_no_hp"><Input style={{ borderRadius: 8 }} /></Form.Item></Col>
								</Row>
							</>
						))}

						{sectionCard('Identitas Kendaraan', <CarOutlined />, '#1e4d8a', (
							<Row gutter={16}>
								<Col xs={24} sm={8}><Form.Item label="Nomor Polisi" name="nomor_polisi" rules={[{ required: true, message: 'Nomor polisi wajib diisi' }]}><Input style={{ borderRadius: 8 }} className="no-uppercase" /></Form.Item></Col>
								<Col xs={24} sm={8}><Form.Item label="Nomor Polisi Lama" name="nomor_polisi_ex"><Input style={{ borderRadius: 8 }} /></Form.Item></Col>
								<Col xs={24} sm={8}><Form.Item label="Nomor Rangka" name="nomor_rangka"><Input style={{ borderRadius: 8 }} /></Form.Item></Col>
								<Col xs={24} sm={8}><Form.Item label="Nomor Mesin" name="nomor_mesin"><Input style={{ borderRadius: 8 }} /></Form.Item></Col>
								<Col xs={24} sm={8}><Form.Item label="No BPKB" name="no_bpkb"><Input style={{ borderRadius: 8 }} /></Form.Item></Col>
								<Col xs={24} sm={8}><Form.Item label="No Kohir" name="no_kohir"><Input style={{ borderRadius: 8 }} /></Form.Item></Col>
								<Col xs={24} sm={8}><Form.Item label="No SKUM" name="no_skum"><Input style={{ borderRadius: 8 }} /></Form.Item></Col>
								<Col xs={24} sm={8}><Form.Item label="No Urut" name="no_urut"><Input style={{ borderRadius: 8 }} /></Form.Item></Col>
							</Row>
						))}

						{sectionCard('Spesifikasi Kendaraan', <SafetyOutlined />, '#389e0d', (
							<Row gutter={16}>
								<Col xs={24} sm={8}>{this._renderSelect('jenis_kendaraan', listJenisKendaraan, 'Jenis Kendaraan', this.handleJenisChange)}</Col>
								<Col xs={24} sm={8}>{this._renderSelect('merek', listMerek, 'Merek', this.handleMerekChange)}</Col>
								<Col xs={24} sm={8}>{this._renderSelect('tipe', listTipe, 'Tipe')}</Col>
								<Col xs={24} sm={8}><Form.Item label="Tahun Buat" name="tahun_buat"><InputNumber style={{ borderRadius: 8, width: '100%' }} /></Form.Item></Col>
								<Col xs={24} sm={8}><Form.Item label="Warna" name="warna"><Input style={{ borderRadius: 8 }} /></Form.Item></Col>
								<Col xs={24} sm={8}>{this._renderSelect('warna_plat', listWarnaPlat, 'Warna Plat')}</Col>
								<Col xs={24} sm={8}>{this._renderSelect('bahan_bakar', listBahanBakar, 'Bahan Bakar')}</Col>
								<Col xs={24} sm={8}><Form.Item label="Roda" name="roda"><InputNumber style={{ borderRadius: 8, width: '100%' }} /></Form.Item></Col>
								<Col xs={24} sm={8}><Form.Item label="Silinder (CC)" name="silinder"><InputNumber style={{ borderRadius: 8, width: '100%' }} /></Form.Item></Col>
								<Col xs={24} sm={8}>{this._renderSelect('fungsi', listFungsi, 'Fungsi')}</Col>
								<Col xs={24} sm={8}>{this._renderSelect('golongan', listGolongan, 'Golongan')}</Col>
								<Col xs={24} sm={8}>{this._renderSelect('kepemilikan', listKepemilikan, 'Kepemilikan')}</Col>
								<Col xs={24} sm={8}><Form.Item label="Kepemilikan Ke" name="kepemilikan_ke"><InputNumber style={{ borderRadius: 8, width: '100%' }} min={1} /></Form.Item></Col>
							</Row>
						))}

						{sectionCard('Wilayah', <EnvironmentOutlined />, '#722ed1', (
							<Row gutter={16}>
								<Col xs={24} sm={8}>{this._renderSelect('kabupaten', listKabupaten, 'Kabupaten', this.handleKabupatenChange, 'name')}</Col>
								<Col xs={24} sm={8}>{this._renderSelect('kecamatan', listKecamatan, 'Kecamatan', this.handleKecamatanChange, 'name')}</Col>
								<Col xs={24} sm={8}>{this._renderSelect('desa', listDesa, 'Desa', undefined, 'name')}</Col>
							</Row>
						))}

						{sectionCard('Tanggal Penting', <CalendarOutlined />, '#08979c', (
							<Row gutter={16}>
								{DATE_FIELDS.map(({ name, label }) => (
									<Col xs={24} sm={8} key={name}>
										<Form.Item label={label} name={name}>
											<DatePicker format="DD-MM-YYYY" style={{ borderRadius: 8, width: '100%' }} />
										</Form.Item>
									</Col>
								))}
							</Row>
						))}

						<div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginBottom: 30 }}>
							<Link to={configClass.pageUrl.data}><Button style={{ borderRadius: 8, height: 40 }}>Batal</Button></Link>
							<Button type="primary" htmlType="submit" icon={<SaveOutlined />} loading={loadingSubmit}
								style={{ background: 'linear-gradient(135deg, #0f2847, #1e4d8a)', border: 'none', borderRadius: 8, fontWeight: 600, height: 40 }}>
								Simpan Perubahan
							</Button>
						</div>
					</Form>
				)}
			</div>
		);
	}
}

const mapStateToProps = (state) => state.configReducers;
export default connect(mapStateToProps, { initHandler, ajaxViewHandler, ajaxHandler, extractResult })(FormKendaraan);
